export const ADMIN_APP_HANDLE = { appContext: "admin" } as const;

export type AppRouteHandle = {
  appContext?: "admin" | "dashboard";
};

declare module "react-router-dom" {
  interface RouteMatch {
    handle?: AppRouteHandle;
  }
}
